import { memo } from 'react';
import { LogoJupyter, Close } from '@carbon/icons-react';
import { Badge } from '../catalyst/badge';
import { cn } from '../../utils';
import { formatFileSize } from '../../utils/attachments';

interface NotebookChipProps {
  filename: string;
  size?: number;
  onRemove?: () => void;
  className?: string;
}

export const NotebookChip = memo<NotebookChipProps>(function NotebookChip({
  filename,
  size,
  onRemove,
  className,
}) {
  const label = size !== undefined ? `${filename} ${formatFileSize(size)}` : filename;

  return (
    <Badge color="amber" className={cn('-translate-x-1.5 translate-y-[5px]', className)}>
      <LogoJupyter size={12} />
      {label}
      {onRemove && (
        <button onClick={onRemove} className="ml-0.5 -mr-0.5 hover:text-foreground">
          <Close size={10} />
        </button>
      )}
    </Badge>
  );
});
